<template>
    <div id="extra-user-documentation">
        <div class="flex justify-between mt-base mb-base">
            <h4>Lista de documentos</h4>
            <vs-button @click.stop="popupActivo = true" color="black" size="small">Agregar nuevo documento</vs-button>
        </div>
        <div class="vx-row">
            <document-upload
                v-for="d in relatedContent"
                :key="d.id"
                :target_id="userId"
                :f="f"
                :doc="document"
                :disabled="false"
                :evaluator="evaluateCondition"
                :loadedState="d"
                :stickToLoadedState="true"
                :editableByBackoffice="true"
                :canVerify="hasRole('credit_risk') || hasRole('project_operator')"
                @on-success="onDocumentUploadSuccess"
            />
        </div>

        <vs-popup title="Agregar documento" :active.sync="popupActivo">
            <div class="vx-row">
                <div class="vx-col">
                    <vx-card title="Nuevo documento">
                        <p class="mb-2">Agrega el nuevo documento al expediente del solicitante. Escribe el nombre 
                            del documento para que lo podamos identificar y selecciona el archivo que deseas subir.
                        </p>
                        <vs-divider></vs-divider>
                    <!-- NOMBRE DEL CONTENIDO -->
               
                        <vs-input label="Nombre" class="w-full mb-2" type="text" v-model="contentName"/>

                        <div v-if="contentSelected == 'document'">
                            <input
                                class="m-4"
                                ref="fileInput"
                                id="extra_layout"
                                text="Seleccione el documento"
                                accept="image/png, image/jpeg, application/pdf"
                                fileName="file" 
                                type="file" />
                        </div>
                        
                        <div v-else>
                            <vs-input label="Link" class="w-full mb-2" type="text" v-model="contentLink"/>
                        </div>
                        

                        <div class="flex flex-wrap items-center justify-end">
                            <vs-button type="line" class="mt-4" @click="popupActivo = false, cleanForm()">Cerrar</vs-button>
                            <vs-button class="ml-2 mt-4" @click="saveContentRequest()">Guardar cambios</vs-button>
                        </div>
                    </vx-card>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import inputHelper from '@components/mixins/inputHelper';

const contentType = [
    { id: "document", select_name: "Documento" }
    , { id: "external_url", select_name: "Link externo" }
    , { id: "internal_url", select_name: "Link interno" }
];

export default {
    name: "extra-project-documentation",
    props: ["userId"],
    mixins: [
        inputHelper
    ],
    data() {
        return {
            relatedContent: [],
            contentType: contentType,
            popupActivo: false,
            contentSelected: "document",
            currentProjectFinanceId: null,
            itemToDelete: null,
            contentName: null,
            contentLink: null,
            document: null,
            f: { 
                "id": 181, 
                "section_id": null, 
                "field_name": "Documento extra", 
                "order": 10, 
                "db_field": "official_id_front_df_id", 
                "db_table": "personal_profiles", 
                "field_type": "text", 
                "min_chars": 0, 
                "max_chars": 0, 
                "is_required": 0, 
                "caps": 0, 
                "collection": null, 
                "doc_id": 181, 
                "block_by_document_id": null, 
                "bo_private": 0, 
                "special_definition": 0, 
                "extras": null, 
                "indication": null, 
                "updated_by": null, 
                "created_at": null, 
                "updated_at": null, 
                "fname": "applicant_extras" 
            }
        }
    },
    mounted() {
        this.getCurrentProjectContent();
    },
    methods: {
        cleanForm(){
            // this.contentSelected = null;
            this.itemToDelete = null;
            this.contentName = null;
            this.contentLink = null;
            document.getElementById('extra_layout').value= null;
        },
        async getCurrentProjectContent()
        {
            try {
                const res = await axios.get(`/api/document/get/applicant/extra/${this.userId}`)
                this.relatedContent = res.data.document_list;
                this.document = res.data.document;
            } catch (error) {
                console.error(error);
            }
        },

        saveContentRequest(item) {
            this.currentProjectFinanceId = item;
            if(this.contentSelected != "document") {
                if(this.contentSelected == null || this.contentName == null || this.contentLink == null){
                    this.missingFieldsNotif();
                    return;
                }
            } else {
                if(this.contentSelected == null || this.contentName == null){
                    this.missingFieldsNotif();
                    return;
                }
            }
            this.$vs.dialog({
                type: 'alert',
                color: 'warning',
                title: "Nuevo documento",
                text: "Se agregara un nuevo documento al expediente ¿deseas continuar?",
                acceptText: "Aceptar",
                cancelText: 'Cancelar',
                accept: this.contentSelected != "document" ? this.doRequestSave : this.doDocumentRequestSave
            });
        },
        async doDocumentRequestSave()
        {
            try {
                const doc = document.getElementById('extra_layout');
                if(doc.files.length === 0){
                    this.errorNotif("Aviso", 'Por favor, carga el documento que será contenido para el proyecto.', 4000);
                    return;
                }
                this.showLoading(true);
    
                let data = new FormData();
                data.append("file", doc.files[0]);
                data.append("user_id", this.userId);
                data.append("name", this.contentName);
    
                await axios.post(`/api/document/post/applicant/new`, data);
    
                this.cleanForm();
                await this.getCurrentProjectContent();
                this.saveSuccessNotif();
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
            }
        },
        async doRequestSave() {
            try {
                this.showLoading(true);
                const payload = {
                    project_id: this.projectId
                    , content_type: this.contentSelected 
                    , name: this.contentName 
                    , link: this.contentLink
                }
                await axios.post(`/api/post/project-related-content/new`, payload);
                this.getCurrentProjectContent();
                this.cleanForm();
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
            }
        },

        deleteContentRequest(item) {
            this.itemToDelete = item;
            this.$vs.dialog({
                type: 'alert',
                color: 'danger',
                title: "Borrar contenido",
                text: "Se eliminará el contenido adicional para el crédito ¿Deseas continuar?",
                acceptText: "Aceptar",
                cancelText: 'Cancelar',
                accept: this.doRequestDelete
            });
        },
        async doRequestDelete() {
            try {
                this.showLoading(true);
                const payload = {
                    content_id: this.itemToDelete.id
                }
                await axios.post(`/api/delete/project-related-content`, payload);
                this.getCurrentProjectContent();
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
            }
        },
        translateContentTypeEnum(type) {
            const types = {
                "document" : "Documentos",
                "external_url" : "Link externo",
                "internal_url" : "Link interno",
                "default" :	"No definido",
            };

            return (types[type] || types["default"]);
        },
        /* evaluator */
        evaluateCondition(condition) {
            return this.evaluateConditionBase(this, condition);
        },
        onDocumentUploadSuccess(data) {
            let d = this.relatedContent.find(f => f.id == data.document_id);
            d.loadedState = data;
        },
    }

}
</script>

<style>
    .con-vs-dialog {
        z-index: 9999999 !important;
    }
</style>